import moment from 'moment';

const serviceRequestFilterTypes = {
  SERVICE_REQUEST_FILTERS_ADD: 'SERVICE_REQUEST_FILTERS_ADD',
  SERVICE_REQUEST_FILTERS_BULK_ADD: 'SERVICE_REQUEST_FILTERS_BULK_ADD',
  SERVICE_REQUEST_FILTERS_REMOVE: 'SERVICE_REQUEST_FILTERS_REMOVE',
  SERVICE_REQUEST_FILTERS_CLEAR: 'SERVICE_REQUEST_FILTERS_CLEAR',
};

export const TYPES = {
  ...serviceRequestFilterTypes,
  AUTH_SIGN_IN_DONE: 'AUTH_SIGN_IN_DONE',
  AUTH_SIGN_IN_ERROR: 'AUTH_SIGN_IN_ERROR',
  AUTH_SIGN_UP_DONE: 'AUTH_SIGN_UP_DONE',
  AUTH_SIGN_UP_ERROR: 'AUTH_SIGN_UP_ERROR',
  AUTH_FORGOT_PASSWORD_DONE: 'AUTH_FORGOT_PASSWORD_DONE',
  AUTH_FORGOT_PASSWORD_ERROR: 'AUTH_FORGOT_PASSWORD_ERROR',
  FETCH_ALL_TICKET_STATUS: 'FETCH_ALL_TICKET_STATUS',
  AUTH_RESET_PASSWORD_DONE: 'AUTH_RESET_PASSWORD_DONE',
  AUTH_RESET_PASSWORD_ERROR: 'AUTH_RESET_PASSWORD_ERROR',
  FETCH_ASSET_BY_ID_DONE: 'FETCH_ASSET_BY_ID_DONE',
  FETCH_ASSET_DOCUMENTS_DONE: 'FETCH_ASSET_DOCUMENTS_DONE',
  FETCH_ASSET_NOTES_DONE: 'FETCH_ASSET_NOTES_DONE',
  FETCH_AUTHENTICATED_USER_DONE: 'FETCH_AUTHENTICATED_USER_DONE',
  FETCH_AVAILABLE_SERVICE_TIMES_DONE: 'FETCH_AVAILABLE_SERVICE_TIMES_DONE',
  CLEAR_AVAILABLE_SERVICE_TIMES: 'CLEAR_AVAILABLE_SERVICE_TIMES',
  FETCH_CONTACT_BY_ID_DONE: 'FETCH_CONTACT_BY_ID_DONE',
  FETCH_CONTACT_NOTES_DONE: 'FETCH_CONTACT_NOTES_DONE',
  FETCH_CONTACT_SERVICE_REQUESTS_DONE: 'FETCH_CONTACT_SERVICE_REQUESTS_DONE',
  FETCH_CONTACTS_DOCUMENTS_DONE: 'FETCH_CONTACTS_DOCUMENTS_DONE',
  FETCH_CONTACTS_DONE: 'FETCH_CONTACTS_DONE',
  FETCH_ITEM_BY_ID_DONE: 'FETCH_ITEM_BY_ID_DONE',
  FETCH_ITEM_DOCUMENTS_DONE: 'FETCH_ITEM_DOCUMENTS_DONE',
  FETCH_FAQS_NOTES_DOCUMENTS_DONE: 'FETCH_FAQ_NOTES_DOCUMENTS_DONE',
  FETCH_ITEM_NOTES_DONE: 'FETCH_ITEM_NOTES_DONE',
  FETCH_ITEMS_DONE: 'FETCH_ITEMS_DONE',
  FETCH_PROPERTIES_DONE: 'FETCH_PROPERTIES_DONE',
  FETCH_PROPERTY_BY_ID_DONE: 'FETCH_PROPERTY_BY_ID_DONE',
  FETCH_PROPERTY_DOCUMENTS_DONE: 'FETCH_PROPERTY_DOCUMENTS_DONE',
  FETCH_PROPERTY_NOTES_DONE: 'FETCH_PROPERTY_NOTES_DONE',
  FETCH_PROPERTY_SERVICE_REQUESTS_DONE: 'FETCH_PROPERTY_SERVICE_REQUESTS_DONE',
  FETCH_PROPERTY_SUITES_DONE: 'FETCH_PROPERTY_SUITES_DONE',
  FETCH_USER_SUITES: 'FETCH_USER_SUITES',
  SET_USER_SUITE: 'SET_USER_SUITE',
  FETCH_SERVICE_REQUEST_BY_ID_DONE: 'FETCH_SERVICE_REQUEST_BY_ID_DONE',
  UPDATE_SERVICE_REQUEST_DONE: 'UPDATE_SERVICE_REQUEST_DONE',
  UPDATE_WARRANTY_ISSUE_STATUS_AND_LOADING:
    'UPDATE_WARRANTY_ISSUE_STATUS_AND_LOADING',
  FETCH_SERVICE_REQUEST_DOCUMENTS_DONE: 'FETCH_SERVICE_REQUEST_DOCUMENTS_DONE',
  FETCH_SERVICE_REQUEST_NOTES_DONE: 'FETCH_SERVICE_REQUEST_NOTES_DONE',
  CLEAR_SERVICE_REQUEST: 'CLEAR_SERVICE_REQUEST',
  FETCH_SERVICE_REQUESTS_DONE: 'FETCH_SERVICE_REQUESTS_DONE',
  FETCH_SERVICE_REQUESTS_SEARCH_DONE: 'FETCH_SERVICE_REQUESTS_SEARCH_DONE',
  FETCH_SUITE_ASSETS_DONE: 'FETCH_SUITE_ASSETS_DONE',
  FETCH_SUITE_BY_ID_DONE: 'FETCH_SUITE_BY_ID_DONE',
  FETCH_SUITE_DOCUMENTS_DONE: 'FETCH_SUITE_DOCUMENTS_DONE',
  FETCH_SUITE_NOTES_DONE: 'FETCH_SUITE_NOTES_DONE',
  FETCH_SUITE_SERVICE_REQUESTS_DONE: 'FETCH_SUITE_SERVICE_REQUESTS_DONE',
  FETCH_TYPEAHEAD_RESULTS_DONE: 'FETCH_TYPEAHEAD_RESULTS_DONE',
  FETCH_TYPEAHEAD_RESULTS: 'FETCH_TYPEAHEAD_RESULTS',
  SAVE_ASSET_DONE: 'SAVE_ASSET_DONE',
  SAVE_CONTACT_DONE: 'SAVE_CONTACT_DONE',
  DELETE_PROPERTY_DONE: 'DELETE_PROPERTY_DONE',
  DELETE_CONTACT_DONE: 'DELETE_CONTACT_DONE',
  ROLES_FETCHED: 'ROLES_FETCHED',
  UPDATE_PROPERTY_DONE: 'UPDATE_PROPERTY_DONE',
  CHANGE_PASSWORD_DONE: 'CHANGE_PASSWORD_DONE',
  DELETE_UNIT_DONE: 'DELETE_UNIT_DONE',
  UPDATE_SUITE_DONE: 'UPDATE_SUITE_DONE',
  DELETE_ITEM_DONE: 'DELETE_ITEM_DONE',
  UPDATE_ITEM_DONE: 'UPDATE_ITEM_DONE',
  SAVE_ASSETS_DONE: 'SAVE_ASSETS_DONE',
  ADD_ASSET_DONE: 'ADD_ASSET_DONE',
  UPDATE_ASSET_DONE: 'UPDATE_ASSET_DONE',
  DELETE_ASSET_DONE: 'DELETE_ASSET_DONE',
  SAVE_CONTACT_NOTE_DONE: 'SAVE_CONTACT_NOTE_DONE',
  SAVE_FAQ_NOTES_DOCUMENTS_DONE: 'SAVE_FAQ_NOTES_DOCUMENTS_DONE',
  UPDATE_FAQ_NOTES_DOCUMENTS_DONE: '_FAQ_NOTES_DOCUMENTS_DONE',
  DELETE_FAQ_NOTES_DOCUMENTS_DONE: 'DELETE_FAQ_NOTES_DOCUMENTS_DONE',
  CLEAR_FAQ_NOTES_DOCUMENTS: 'CLEAR_FAQ_NOTES_DOCUMENTS',
  SAVE_ITEM_DONE: 'SAVE_ITEM_DONE',
  SAVE_PROPERTY_DONE: 'SAVE_PROPERTY_DONE',
  SAVE_SUITE_DONE: 'SAVE_SUITE_DONE',
  SAVE_FAQ_DONE: 'SAVE_FAQ_DONE',
  SET_CONTACT_FORM_DATA: 'SET_CONTACT_FORM_DATA',
  SET_ITEM_FORM_DATA: 'SET_ITEM_FORM_DATA',
  CLEAR_ITEM_FORM_DATA: 'CLEAR_ITEM_FORM_DATA',
  SET_PROPERTY_FORM_DATA: 'SET_PROPERTY_FORM_DATA',
  CLEAR_PROPERTY_FORM_DATA: 'CLEAR_PROPERTY_FORM_DATA',
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  CLEAR_ACTIVE_TAB: 'CLEAR_ACTIVE_TAB',
  SET_ACTIVE_SUITE_TAB: 'SET_ACTIVE_SUITE_TAB',
  CLEAR_ACTIVE_SUITE_TAB: 'CLEAR_ACTIVE_SUITE_TAB',
  SET_ACTIVE_COMMONAREA_TAB: 'SET_ACTIVE_COMMONAREA_TAB',
  CLEAR_ACTIVE_COMMONAREA_TAB: 'CLEAR_ACTIVE_COMMONAREA_TAB',
  SET_ACTIVE_CONTACT_TAB: 'SET_ACTIVE_CONTACT_TAB',
  CLEAR_ACTIVE_CONTACT_TAB: 'CLEAR_ACTIVE_CONTACT_TAB',
  SET_ACTIVE_CATALOG_TAB: 'SET_ACTIVE_CATALOG_TAB',
  CLEAR_ACTIVE_CATALOG_TAB: 'CLEAR_ACTIVE_CATALOG_TAB',
  SET_TAB_LIST: 'SET_TAB_LIST',
  SET_ALLOWED_TAB_LIST: 'SET_ALLOWED_TAB_LIST',
  SET_SELECTED_MODULE_PERMISSION: 'SET_SELECTED_MODULE_PERMISSION',
  CLEAR_TAB_LIST: 'CLEAR_TAB_LIST',
  CLEAR_ALLOWED_TAB_LIST: 'CLEAR_ALLOWED_TAB_LIST',
  CLEAR_SELECTED_MODULE_PERMISSION: 'CLEAR_SELECTED_MODULE_PERMISSION',
  SET_SERVICE_REQUEST_FORM_DATA: 'SET_SERVICE_REQUEST_FORM_DATA',
  SET_SERVICE_REQUEST_FORM_NEXT_STEP: 'SET_SERVICE_REQUEST_FORM_NEXT_STEP',
  SET_SERVICE_REQUEST_FORM_PREVIOUS_STEP:
    'SET_SERVICE_REQUEST_FORM_PREVIOUS_STEP',
  SET_SERVICE_REQUEST_FORM_STEP: 'SET_SERVICE_REQUEST_FORM_STEP',
  EXIT_SERVICE_REQUEST_FORM: 'EXIT_SERVICE_REQUEST_FORM',
  CLEAR_SERVICE_REQUESTS_FORM_DATA: 'CLEAR_SERVICE_REQUESTS_FORM_DATA',
  SET_SERVICE_REQUEST_FORM_IS_VISIBLE: 'SET_SERVICE_REQUEST_FORM_IS_VISIBLE',
  SAVE_SERVICE_REQUEST_DONE: 'SAVE_SERVICE_REQUEST_DONE',
  SAVE_SERVICE_REQUEST_BY_GROUP: 'SAVE_SERVICE_REQUEST_BY_GROUP',
  SET_CURRENT_GROUP_SERVICE_REQUEST_INDEX:
    'SET_CURRENT_GROUP_SERVICE_REQUEST_INDEX',
  SET_DISPLAY_CLOSE_AND_RESOLVED_TICKETS:
    'SET_DISPLAY_CLOSE_AND_RESOLVED_TICKETS',
  CLEAR_SAVE_SERVICE_REQUEST_BY_GROUP: 'CLEAR_SAVE_SERVICE_REQUEST_BY_GROUP',
  DELETE_SERVICE_REQUEST_DONE: 'DELETE_SERVICE_REQUEST_DONE',
  SET_EMAIL_TEMPLATES: 'SET_EMAIL_TEMPLATES',
  SET_EMAIL_TEMPLATE_FORM: 'SET_EMAIL_TEMPLATE_FORM',
  CLEAR_EMAIL_TEMPLATE_FORM: 'CLEAR_EMAIL_TEMPLATE_FORM',
  CLEAR_EMAIL_TEMPLATES: 'CLEAR_EMAIL_TEMPLATE_FORM',
  SAVE_STATUS_DONE: 'SAVE_STATUS_DONE',
  FETCH_ALL_ITEM_TYPES_DONE: 'FETCH_ALL_ITEM_TYPES_DONE',
  GET_ALL_USER_TYPE_ROLES: 'GET_ALL_USER_TYPE_ROLES',
  CLEAR_CONTACT_FORM_DATA: 'CLEAR_CONTACT_FORM_DATA',
  UPDATE_CONTACT_DONE: 'UPDATE_CONTACT_DONE',
  SET_SUITE_FORM_DATA: 'SET_SUITE_FORM_DATA',
  CLEAR_SUITE_FORM_DATA: 'CLEAR_SUITE_FORM_DATA',
  FETCH_ALL_ISSUE_TYPES: 'FETCH_ALL_ISSUE_TYPES',
  SET_FND_FORM_DATA: 'SET_FND_FORM_DATA',
  CLEAR_FND_FORM_DATA: 'CLEAR_FND_FORM_DATA',
  SET_ASSET_FORM_DATA: 'SET_ASSET_FORM_DATA',
  CLEAR_ASSET_FORM_DATA: 'CLEAR_ASSET_FORM_DATA',
  SET_SEARCH: 'SET_SEARCH',
  CLEAR_SEARCH: 'CLEAR_SEARCH',
  FETCH_MESSAGES_DONE: 'FETCH_MESSAGES_DONE',
  POST_MESSAGE_DONE: 'POST_MESSAGE_DONE',
  USER_PROFILE_DETAILS_FETCHED: 'USER_PROFILE_DETAILS_FETCHED',
  SET_SETTINGS_FORM_DATA: 'SET_SETTINGS_FORM_DATA',
  UPDATE_COMPANY_DETAILS_DONE: 'UPDATE_COMPANY_DETAILS_DONE',
  UPDATE_NOTIFICATION_DETAILS_DONE: 'UPDATE_NOTIFICATION_DETAILS_DONE',
  CLEAR_SUITES: 'CLEAR_SUITES',
  CLEAR_ASSETS: 'CLEAR_ASSETS',
  CLEAR_MESSAGES: 'CLEAR_MESSAGES',
  CLEAR_SERVICE_REQUESTS_DONE: 'CLEAR_SERVICE_REQUESTS_DONE',
  FETCH_MAINTENANCE_GUIDE_FOR_ASSET_BY_ITEM_ID_DONE:
    'FETCH_MAINTENANCE_GUIDE_FOR_ASSET_BY_ITEM_ID_DONE',
  FETCH_FAQS_FOR_ASSET_BY_ITEM_ID_DONE: 'FETCH_FAQS_FOR_ASSET_BY_ITEM_ID_DONE',

  FETCH_SUITE_AREAS_DONE: 'FETCH_SUITE_AREAS_DONE',
  FETCH_SUITE_ASSET_AREAS_DONE: 'FETCH_SUITE_ASSET_AREAS_DONE',

  SET_PROPERTY_WALK_THROUGH_FORM_IS_VISIBLE:
    'SET_PROPERTY_WALK_THROUGH_FORM_IS_VISIBLE',
  SET_PROPERTY_WALK_THROUGH_FORM_DATA: 'SET_PROPERTY_WALK_THROUGH_FORM_DATA',
  SET_PROPERTY_WALK_THROUGH_FORM_NEXT_STEP:
    'SET_PROPERTY_WALK_THROUGH_FORM_NEXT_STEP',
  SET_PROPERTY_WALK_THROUGH_FORM_PREVIOUS_STEP:
    'SET_PROPERTY_WALK_THROUGH_FORM_PREVIOUS_STEP',
  SET_PROPERTY_WALK_THROUGH_FROM_STEP: 'SET_PROPERTY_WALK_THROUGH_FROM_STEP',
  EXIT_PROPERTY_WALK_THROUGH_FORM: 'EXIT_PROPERTY_WALK_THROUGH_FORM',
  FETCH_AREAS_AND_SUB_AREAS: 'FETCH_AREAS_AND_SUB_AREAS',
  CHANGE_SEQUENCE_AREAS_AND_SUBAREAS: 'CHANGE_SEQUENCE_AREAS_AND_SUBAREAS',

  SET_EASY_WALK_THROUGH_FORM_NEXT_STEP: 'SET_EASY_WALK_THROUGH_FORM_NEXT_STEP',
  SET_EASY_WALK_THROUGH_FROM_STEP: 'SET_EASY_WALK_THROUGH_FROM_STEP',
  SET_EASY_WALK_THROUGH_FORM_DATA: 'SET_EASY_WALK_THROUGH_FORM_DATA',
  SET_EASY_WALK_THROUGH_FORM_PREVIOUS_STEP:
    'SET_EASY_WALK_THROUGH_FORM_PREVIOUS_STEP',
  EXIT_EASY_WALK_THROUGH_FORM: 'EXIT_EASY_WALK_THROUGH_FORM',

  GET_WALK_THROUGH_SUITES: 'GET_WALK_THROUGH_SUITES',
  SET_OFFLINE_WALKTHROUGH_SAVE_ACTIONS: 'SET_OFFLINE_WALKTHROUGH_SAVE_ACTIONS',
  CLEAR_OFFLINE_WALKTHROUGH_SAVE_ACTIONS:
    'CLEAR_OFFLINE_WALKTHROUGH_SAVE_ACTIONS',

  SET_LOADER_LOADING: 'SET_LOADER_LOADING',
  STOP_LOADER_LOADING: 'STOP_LOADER_LOADING',
  SET_PRLOADER_LOADING: 'SET_PRLOADER_LOADING',
  STOP_PRLOADER_LOADING: 'STOP_PRLOADER_LOADING',
  SET_FORMLOADER_LOADING: 'SET_FORMLOADER_LOADING',
  STOP_FORMLOADER_LOADING: 'STOP_FORMLOADER_LOADING',

  SET_VALIDATION: 'SET_VALIDATION',
  CLEAR_VALIDATION: 'CLEAR_VALIDATION',
  PROPERTY_MANAGER_DETAILS_DONE: 'PROPERTY_MANAGER_DETAILS_DONE',
  PROPERTY_MANAGER_CALENDLY_DONE: 'PROPERTY_MANAGER_CALENDLY_DONE',
  FETCH_RECENT_ACTIVITY_DONE: 'FETCH_RECENT_ACTIVITY_DONE',

  CLEAR_GLOBAL_SEARCH: 'CLEAR_GLOBAL_SEARCH',

  SET_ANNOUNCEMENT_FORM_DATA: 'SET_ANNOUNCEMENT_FORM_DATA',
  CLEAR_ANNOUNCEMENT_FORM_DATA: 'CLEAR_ANNOUNCEMENT_FORM_DATA',
  FETCH_ANNOUNCEMENTS_DONE: 'FETCH_ANNOUNCEMENTS_DONE',
  SAVE_ANNOUNCEMENTS_DONE: 'SAVE_ANNOUNCEMENTS_DONE',
  DELETE_ANNOUNCEMENTS_DONE: 'DELETE_ANNOUNCEMENTS_DONE',
  CLEAR_ANNOUNCEMENTS_DONE: 'CLEAR_ANNOUNCEMENTS_DONE',
  FETCH_COMMON_AREAS_DONE: 'FETCH_COMMON_AREAS_DONE',
  FETCH_PROPERTY_COMMON_AREAS_DONE: 'FETCH_PROPERTY_COMMON_AREAS_DONE',
  FETCH_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE:
    'FETCH_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE',
  SELECTION_OF_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE:
    'SELECTION_OF_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE',
  CLEAR_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE:
    'CLEAR_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE',
  CLEAR_SELECTED_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE:
    'CLEAR_SELECTED_PROPERTY_COMMON_AREAS_FOR_FILTER_DONE',

  FETCH_WALK_THROUGHS_DONE: 'FETCH_WALK_THROUGHS_DONE',

  FETCH_SUITE_USERS_LIST: 'FETCH_SUITE_USERS_LIST',
  SAVE_SUITE_CONTACT_DONE: 'SAVE_SUITE_CONTACT_DONE',
  UPDATE_SUITE_CONTACT_DONE: 'UPDATE_SUITE_CONTACT_DONE',
  CLEAR_SUITE_USERS: 'CLEAR_SUITE_USERS',
  SUITE_UPDATE_SYNC_STATUS_DONE: 'SUITE_UPDATE_SYNC_STATUS_DONE',

  FETCH_OVER_VIEW_STATUS_DAYS_DONE: 'FETCH_OVER_VIEW_STATUS_DAYS_DONE',

  FETCH_COMMON_ISSUES_DONE: 'FETCH_COMMON_ISSUES_DONE',
  SAVE_COMMON_ISSUE_DONE: 'SAVE_COMMON_ISSUE_DONE',
  UPDATE_COMMON_ISSUE_DONE: 'UPDATE_COMMON_ISSUE_DONE',
  DELETE_COMMON_ISSUE_DONE: 'DELETE_COMMON_ISSUE_DONE',
  CLEAR_COMMON_ISSUE_DONE: 'CLEAR_COMMON_ISSUE_DONE',

  FETCH_COMMON_AREA_ASSETS_DONE: 'FETCH_COMMON_AREA_ASSETS_DONE',
  SET_COMMON_AREA_ASSET_FORM_DATA: 'SET_COMMON_AREA_ASSET_FORM_DATA',
  CLEAR_COMMON_AREA_ASSET_FORM_DATA: 'CLEAR_COMMON_AREA_ASSET_FORM_DATA',

  SAVE_COMMON_AREA_DONE: 'SAVE_COMMON_AREA_DONE',
  UPDATE_COMMON_AREA_DONE: 'UPDATE_COMMON_AREA_DONE',
  DELETE_COMMON_AREA_DONE: 'DELETE_COMMON_AREA_DONE',
  FETCH_PROPERTY_DEVELOPERS_DONE: 'FETCH_PROPERTY_DEVELOPERS_DONE',
  UPDATE_PROPERTY_DEVELOPERS_DONE: 'UPDATE_PROPERTY_DEVELOPERS_DONE',
  DELETE_PROPERTY_DEVELOPERS_DONE: 'DELETE_PROPERTY_DEVELOPERS_DONE',

  SERVICE_REQUEST_PAGINATION: 'SERVICE_REQUEST_PAGINATION',
  SERVICE_REQUEST_PAGE_COUNT: 'SERVICE_REQUEST_PAGE_COUNT',
  CLEAR_PAGE_COUNT: 'CLEAR_PAGE_COUNT',
  CLEAR_PAGINATION_COUNT: 'CLEAR_PAGINATION_COUNT',

  FETCH_COUNTS_DONE: 'FETCH_COUNTS_DONE',
  CLEAR_COUNTS_DONE: 'CLEAR_COUNTS_DONE',
  UPDATE_SERVICE_REQUEST_STATUS_DONE: 'UPDATE_SERVICE_REQUEST_STATUS_DONE',
  ADD_FILTER_QUERY: 'ADD_FILTER_QUERY',
  CLEAR_FILTER_REQUEST: 'CLEAR_FILTER_REQUEST',
  ADD_FILTER_SERVICE_PROVIDER_AND_PROPERTY_DEVELOPER:
    'ADD_FILTER_SERVICE_PROVIDER_AND_PROPERTY_DEVELOPER',
  CLEAR_FILTER_SERVICE_PROVIDER_AND_PROPERTY_DEVELOPER:
    'CLEAR_FILTER_SERVICE_PROVIDER_AND_PROPERTY_DEVELOPER',
  ADD_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV:
    'ADD_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV',
  CLEAR_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV:
    'CLEAR_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV',

  ARCHIVE_SERVICE_REQUESTS_DONE: 'ARCHIVE_SERVICE_REQUESTS_DONE',
  FETCH_REPORTS_DONE: 'FETCH_REPORTS_DONE',
  CLEAR_REPORTS_DONE: 'CLEAR_REPORTS_DONE',

  FETCH_SERVICE_REQUEST_ACTIVITY_BY_ID_DONE:
    'FETCH_SERVICE_REQUEST_ACTIVITY_BY_ID_DONE',
  FETCHED_SUITE_USERS_ADD_TO_CONTACTS_DONE:
    'FETCHED_SUITE_USERS_ADD_TO_CONTACTS_DONE',

  START_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV:
    'START_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV',
  STOP_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV:
    'STOP_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV',
  CLEAR_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV:
    'CLEAR_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV',
  FETCHED_DOWNLOAD_SERVICE_REQUEST_LIST_CSV_DONE:
    'FETCHED_DOWNLOAD_SERVICE_REQUEST_LIST_CSV_DONE',
  SET_MAIN_SERVICE_REQUEST_PDF_DOWNLOAD_LIST:
    'SET_MAIN_SERVICE_REQUEST_PDF_DOWNLOAD_LIST',
  SET_SIDE_BAR: 'SET_SIDE_BAR',

  FETCH_VIDEOS_DONE: 'FETCH_VIDEOS_DONE',
  FETCH_MAINTAINANCE_GUIDE_BY_SUITE_ID: 'FETCH_MAINTAINANCE_GUIDE_BY_SUITE_ID',
  GET_PROPERTY_BUILDINGS_DONE: 'GET_PROPERTY_BUILDINGS_DONE',
  GET_BUILDING_LEVELS_DONE: 'GET_BUILDING_LEVELS_DONE',
  HOMEOWNER_ONBOARDING_FORM_DATA: 'HOMEOWNER_ONBOARDING_FORM_DATA',
  CLEAR_HOMEOWNER_ONBOARDING_FORM_DATA: 'CLEAR_HOMEOWNER_ONBOARDING_FORM_DATA',
  HOMEOWNER_ONBOARDING_DATA: 'HOMEOWNER_ONBOARDING_DATA',
  FETCH_HOMEOWNER_ONBOARDING_DATA: 'FETCH_HOMEOWNER_ONBOARDING_DATA',
  CLEAR_HOMEOWNER_ONBOARDING_DATA: 'CLEAR_HOMEOWNER_ONBOARDING_DATA',
  GET_SUITE_STATUSES_DONE: 'GET_SUITE_STATUSES_DONE',
  FETCH_PROPERTY_STAGES: 'FETCH_PROPERTY_STAGES',
  FETCH_PROPERTY_STATUSES: 'FETCH_PROPERTY_STATUSES',
  SORTING_FAQS_HOMEOWNER_ONBOARDING_DATA:
    'SORTING_FAQS_HOMEOWNER_ONBOARDING_DATA',
  FETCH_CONSTRUCTION_STAGES_DONE: 'FETCH_CONSTRUCTION_STAGES_DONE',
  CLEAR_CONSTRUCTION_STAGES_DONE: 'CLEAR_CONSTRUCTION_STAGES_DONE',
  FETCH_MORE_DETAILS_DONE: 'FETCH_MORE_DETAILS_DONE',
  CLEAR_MORE_DETAILS_DONE: 'CLEAR_MORE_DETAILS_DONE',
  IS_FETCH_MORE_DETAILS_LOADING: 'IS_FETCH_MORE_DETAILS_LOADING',
  CLOSE_FETCH_MORE_DETAILS_LOADING: 'CLOSE_FETCH_MORE_DETAILS_LOADING',
  FETCH_ONBOARDING_ORDERS: 'FETCH_ONBOARDING_ORDERS',
  SAVE_ONBOARDING_ORDER_ID: 'SAVE_ONBOARDING_ORDER_ID',
  FETCH_ONBOARDING_ORDER_DETAILS: 'FETCH_ONBOARDING_ORDER_DETAILS',
  CLEAR_FETCH_ONBOARDING_ORDER_DETAILS: 'CLEAR_FETCH_ONBOARDING_ORDER_DETAILS',
  FETCH_ONBOARDING_ORDER_DETAILS_LOADING:
    'FETCH_ONBOARDING_ORDER_DETAILS_LOADING',
  SET_ONBOARDING_ORDER_CHECKLISTDETAILS:
    'SET_ONBOARDING_ORDER_CHECKLISTDETAILS',
  SET_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS:
    'SET_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS',
  SET_ONBOARDING_ORDER_CHECKLIST_NOTES: 'SET_ONBOARDING_ORDER_CHECKLIST_NOTES',
  CLEAR_FETCH_ONBOARDING_ORDERS: 'CLEAR_FETCH_ONBOARDING_ORDERS',
  CLEAR_PROPERTY_MANAGER_DETAILS: 'CLEAR_PROPERTY_MANAGER_DETAILS',
  FETCH_ORDERS_LOADING: 'FETCH_ORDERS_LOADING',
  DELETE_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS:
    'DELETE_ONBOARDING_ORDER_CHECKLIST_DOCUMENTS',
  FETCH_CONVEYANCE_FORM: 'FETCH_CONVEYANCE_FORM',
  CLEAR_CONVEYANCE_FORM: 'CLEAR_CONVEYANCE_FORM',
  FETCH_CONVEYANCE_FORM_DATA: 'FETCH_CONVEYANCE_FORM_DATA',
  CLEAR_FETCH_CONVEYANCE_FORM_DATA: 'CLEAR_FETCH_CONVEYANCE_FORM_DATA',

  DELETE_HOMEOWNER_ONBOARDING_ORDER_DATA:
    'DELETE_HOMEOWNER_ONBOARDING_ORDER_DATA',
  FETCH_PROPERTIES_CATALOG_DONE: 'FETCH_PROPERTIES_CATALOG_DONE',
  CLEAR_PROPERTIES_CATALOG_DONE: 'CLEAR_PROPERTIES_CATALOG_DONE',
  SET_WALKTHROUGH_REVIEW_STATUS: 'SET_WALKTHROUGH_REVIEW_STATUS',
  CLEAR_KEY_CONTACTS_DONE: 'CLEAR_KEY_CONTACTS_DONE',
  FETCH_KEY_CONTACTS_DONE: 'FETCH_KEY_CONTACTS_DONE',
  FETCH_INBOX_LIST_DONE: 'FETCH_INBOX_LIST_DONE',
  CLEAR_INBOX_LIST_DONE: 'CLEAR_INBOX_LIST_DONE',
  FETCH_CHAT_MESSAGES_DONE: 'FETCH_CHAT_MESSAGES_DONE',
  FETCH_INBOX_ANNOUNCEMENTS_LIST_DONE: 'FETCH_INBOX_ANNOUNCEMENTS_LIST_DONE',
  CLEAR_INBOX_CHAT_MESSAGES_DONE: 'CLEAR_INBOX_CHAT_MESSAGES_DONE',
  START_INBOX_LOADER: 'START_INBOX_LOADER',
  FETCH_CHAT_USER_INFORMATION_DONE: 'FETCH_CHAT_USER_INFORMATION_DONE',
  STOP_INBOX_LOADER: 'STOP_INBOX_LOADER',
  FETCH_INBOX_ANNOUNCEMENTS_DONE: 'FETCH_INBOX_ANNOUNCEMENTS_DONE',
  SET_ANNOUNCEMENT: 'SET_ANNOUNCEMENT',
  CLEAR_INBOX_ANNOUNCEMENTS_BY_PROPERTY:
    'CLEAR_INBOX_ANNOUNCEMENTS_BY_PROPERTY',
  FETCH_INBOX_SUITES_LIST_DONE: 'FETCH_INBOX_SUITES_LIST_DONE',
  SAVE_INBOX_ITEM: 'SAVE_INBOX_ITEM',
  CLEAR_CHAT_USER_INFORMATION_DONE: 'CLEAR_CHAT_USER_INFORMATION_DONE',
  FETCH_INBOX_SERVICE_REQUESTS_LIST_DONE:
    'FETCH_INBOX_SERVICE_REQUESTS_LIST_DONE',
  SAVE_MESSAGE_IN_LOCAL_LIST: 'SAVE_MESSAGE_IN_LOCAL_LIST',
  INBOX_SERVICE_REQUEST_PAGINATION: 'INBOX_SERVICE_REQUEST_PAGINATION',
  INBOX_SERVICE_REQUEST_PAGE_COUNT: 'INBOX_SERVICE_REQUEST_PAGE_COUNT',
  CLEAR_INBOX_PAGINATION_COUNT: 'CLEAR_INBOX_PAGINATION_COUNT',
  FETCH_INBOX_SERVICE_REQUESTS_LIST_SEARCH_DONE:
    'FETCH_INBOX_SERVICE_REQUESTS_LIST_SEARCH_DONE',
  CLEAR_INBOX_SERVICE_REQUESTS: 'CLEAR_INBOX_SERVICE_REQUESTS',
  SAVE_SELECTED_ITEM_DONE: 'SAVE_SELECTED_ITEM_DONE',
  SAVE_SEND_MESSAGE_TO_CHAT_LIST: 'SAVE_SEND_MESSAGE_TO_CHAT_LIST',
  SAVE_WALKTHROUGH: 'SAVE_WALKTHROUGH',
  DELETE_WALKTHROUGH_DONE: 'DELETE_WALKTHROUGH_DONE',
  CLEAR_WALKTHROUGH_DONE: 'CLEAR_WALKTHROUGH_DONE',
  SAVE_SUITE_RESPONSE_DONE: 'SAVE_SUITE_RESPONSE_DONE',
  SAVE_ITEMS_RESPONSE_DONE: 'SAVE_ITEMS_RESPONSE_DONE',
  CLEAR_RESPONSE_DONE: 'CLEAR_RESPONSE_DONE',
  CLEAR_SUITE_ASSET_AREAS_DONE: 'CLEAR_SUITE_ASSET_AREAS_DONE',
  UPDATE_MESSAGE_TO_INREAD_TO_READ: 'UPDATE_MESSAGE_TO_INREAD_TO_READ',
  FETCH_SUITE_FAQS_DONE: 'FETCH_SUITE_FAQS_DONE',
  SPECIFICATION_SAVE_DONE: 'SPECIFICATION_SAVE_DONE',
  SPECIFICATION_UPDATE_DONE: 'SPECIFICATION_UPDATE_DONE',
  FETCH_SPECIFICATIONS_DONE: 'FETCH_SPECIFICATIONS_DONE',
  SPECIFICATION_DELETE_DONE: 'SPECIFICATION_DELETE_DONE',
  CLEAR_SPECIFICATIONS_DONE: 'CLEAR_SPECIFICATIONS_DONE',
  FETCH_KEY_PICKUP_SERVICE_REQUESTS_DONE:
    'FETCH_KEY_PICKUP_SERVICE_REQUESTS_DONE',
  FETCH_KEY_PICKUP_IMPORTANT_DOCUMENTS_DONE:
    'FETCH_KEY_PICKUP_IMPORTANT_DOCUMENTS_DONE',
  CLEAR_KEY_PICKUP_DONE: 'CLEAR_KEY_PICKUP_DONE',
  KEY_PICKUP_LOADING_DONE: 'KEY_PICKUP_LOADING_DONE',
  SET_BUILD_VERSION: 'SET_BUILD_VERSION',
  FETCH_SERVICE_REQUEST_TAGS_DONE: 'FETCH_SERVICE_REQUEST_TAGS_DONE',
  FETCH_SERVICE_REQUEST_STATS_DONE: 'FETCH_SERVICE_REQUEST_STATS_DONE',
  CLEAR_SERVICE_REQUEST_STATS_DONE: 'CLEAR_SERVICE_REQUEST_STATS_DONE',
  FETCH_CUSTOMER_FEEDBACK_DONE: 'FETCH_CUSTOMER_FEEDBACK_DONE',
  FETCH_NOTES: 'FETCH_NOTES',
  CLEAR_NOTES: 'CLEAR_NOTES',
};

export const PATHS = {
  ASSETS_VIEW: '/app/assets/:id',
  AUTH_FORGOT_PASSWORD: '/auth/forgot-password',
  AUTH_RESET_PASSWORD: '/auth/reset-password',
  AUTH_ACTIVATE: '/auth/activate',
  AUTH_SIGN_IN: '/auth/sign-in',
  AUTH_SIGN_OUT: '/auth/sign-out',
  AUTH_SIGN_UP: '/auth/sign-up',
  CONTACTS_LIST: '/app/contacts',
  CONTACTS_VIEW: '/app/contacts/:id',
  ITEMS_LIST: '/app/catalog',
  PROPERTIES_LIST: '/app/properties',
  PROPERTIES_VIEW: '/app/properties/:id',
  SERVICE_REQUESTS_LIST: '/app/service-requests',
  SERVICE_REQUESTS_VIEW: '/app/service-requests/:id',
  SETTINGS: '/app/settings',
  CHANGE_PASSWORD: '/app/changepassword',
  SUITES_VIEW: '/app/suites/:id',
  ITEMS_VIEW: '/app/items/:id',
  ACTIVATE: '/auth/activate',
  VIDEO_CHAT: '/app/videoChat',
  VIEW_IMAGE: '/app/viewImage',
  DASHBOARD: '/app/dashboard',
  EVENT_ADDING: '/app/addevent',
  ANNOUNCEMENTS: '/app/announcements',
  ANNOUNCEMENTS_VIWE: '/app/announcement/:id',
  COMMON_AREA_VIEW: '/app/commonareas/:id',
  REPORTING: '/app/reporting',
  KEY_CONTACTS_LIST: '/app/keycontacts',
  KEY_CONTACTS_VIEW: '/app/keycontacts/:id',
  HOMEOWNER_ONBOARDING: '/app/homeowneronboarding',
  HOMEOWNER_ONBOARDING_DASHBOARD: '/app/homeowneronboardingdashboard',
  INBOX: '/app/inbox',
  REQUEST: '/app/request',
  EMAIL_TEMPLATES: '/app/emailtemplates',
};

export const ICONS = {
  Accessibility: 'wheelchair',
  Contract: 'file-contract',
  Dryer: 'dryer',
  Electrical: 'bolt',
  Exteriors: 'door-open',
  Exterior: 'door-open',
  Refrigerator: 'refrigerator',
  Other: 'house-damage',
  OtherDoc: 'file-alt',
  General: 'house-damage',
  Heating: 'temperature-hot',
  'Home Owner': 'home-owner',
  Realtor: 'home-owner',
  Image: 'image',
  Invoice: 'file-invoice-dollar',
  Microwave: 'microwave',
  'Owners Manual': 'tools',
  Plumbing: 'toilet',
  'Property Developer': 'property-manager',
  'Strata Manager': 'property-manager',
  'Service Provider': 'service-provider',
  Spreadsheet: 'file-spreadsheet',
  Ventilation: 'fan',
  Warranty: 'shield-check',
  Washer: 'washer',
  Submitted: 'submitted',
  Scheduled: 'scheduled',
  Assigned: 'assigned',
  Approved: 'approved',
  'En Route': 'en-route',
  'On Hold': 'on-hold',
  'In Progress': 'in-progress',
  Resolved: 'resolved',
  Declined: 'declined',
  Closed: 'closed',
  'Under Review': 'hourglass-end',
  TV: 'tv',
  'Create New': 'plus',
  'Copy From Existing': 'clone',
  Guided: 'handshake',
  'Self-Guided': 'walking',
  Vendor: 'service-provider',
  Video: 'video',
  HVAC: 'air-conditioner',
  Faucet: 'faucet',
  Thermostat: 'sort-circle',
  'Shower / Tub': 'bath',
  Window: 'window-frame',
  'Window Covering': 'blinds',
  Oven: 'oven',
  Furnace: 'fireplace',
  'Washing Machine': 'washer',
  Toilet: 'toilet',
  Doors: 'door-closed',
  Cabinetry: 'cabinet-filing',
  'Extractor Fan': 'fan',
  Tile: 'square',
  'Hood Fan': 'fan',
  Range: 'box-full',
  Mirrors: 'send-backward',
  Paint: 'paint-brush-alt',
  Sink: 'bath',
  'Casing/Millwork': 'digital-tachograph',
  Lighting: 'lightbulb',
  'Flooring - Tile': 'square',
  'Bathroom Accessories': 'toilet ',
  'In-Sink Disposal': 'bath',
  'Flooring - Vinyl': 'record-vinyl',
  'Flooring - Other': 'rectangle-landscape',
  'Flooring - Laminate': 'align-justify',
  Landscaping: 'rectangle-landscape',
  Dishwasher: 'washer',
  'Flooring - Hardwood': 'house',
  'Flooring - Carpet': 'house',
  Countertop: 'house',
  Occupant: 'home-owner',
  'Heating/Cooling': 'air-conditioner',
  Finishing: 'ballot-check',
  'Electrical Outlet': 'bolt',
  'Service Manager': 'service-provider',
};

export const ICO_MOON = {
  'Service Request': 'service-request',
  Property: 'property',
  Contact: 'contact',
  Item: 'item',
};

export const ITEM_TYPES = ['Refrigerator', 'Washer'];

export const ITEM_WARRANTIES = [1, 2, 3, 5, 10, 0];

export const ASSET_ROOMS = [
  'Master Bedroom',
  'Bedroom 1',
  'Bedroom 2',
  'Bedroom 3',
  'Bedroom 4',
  'Kitchen',
  'Dining Room',
  'Living Room',
  'Den',
  'Bathroom 1',
  'Bathroom 2',
  'Bathroom 3',
  'Bathroom 4',
  'Ensuite',
  'Powder Room',
  'Entry',
  'Exterior Back',
  'Exterior Front',
  'Garage',
  'Hallway',
  'Laundry',
  'Closet 1',
  'Closet 2',
  'Closet 3',
  'Closet 4',
  'Closet 5',
  'Closet 6',
  'Pantry',
  'Basement',
  'Deck/Patio',
  'Yard Back',
  'Yard Front',
  'Elevator',
  'Other',
];

export const USER_TYPES = [
  'Property Developer',
  'Strata Manager',
  'Home Owner',
  'Realtor',
  'Service Provider',
  'Vendor',
  'Occupant',
  'Service Manager',
];

export const DOCUMENT_TYPES = [
  'Warranty',
  'Owners Manual',
  'Image',
  'Invoice',
  'Spreadsheet',
  'Contract',
  'General',
  'Video',
];

export const ISSUE_TYPES = [
  'Accessibility',
  'Electrical',
  'Exteriors',
  'Heating',
  'Plumbing',
  'Ventilation',
  'Other',
];

export const WORK_DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
];

export const PANATCH_WORK_DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
];

export const ALL_SLOTS =
  'Monday Mornings ( 8 AM - 11 AM ),Monday Afternoons ( 1 PM - 5 PM ),Monday Evenings ( 5 PM - 8 PM ),Tuesday Mornings ( 8 AM - 11 AM ),Tuesday Afternoons ( 1 PM - 5 PM ),Tuesday Evenings ( 5 PM - 8 PM ),Wednesday Mornings ( 8 AM - 11 AM ),Wednesday Afternoons ( 1 PM - 5 PM ),Wednesday Evenings ( 5 PM - 8 PM ),Thursday Mornings ( 8 AM - 11 AM ),Thursday Afternoons ( 1 PM - 5 PM ),Thursday Evenings ( 5 PM - 8 PM ),Friday Mornings ( 8 AM - 11 AM ),Friday Afternoons ( 1 PM - 5 PM ),Friday Evenings ( 5 PM - 8 PM )';
export const TIME_SLOTS = ['Morning', 'Afternoon', 'Other:'];

export const PANATCH_TIME_SLOTS = ['Morning', 'Afternoon', 'Other:'];

export const ALBASTAR_TIME_SLOTS = [
  '7:30 - 11:30',
  '11:30 - 3:30',
  'All day',
  'Other:',
];

export const WALKTHROUGH_TIME_SLOTS = [
  'Mornings ( 8 AM - 11 AM )',
  'Afternoons ( 1 PM - 5 PM )',
  'Evenings ( 5 PM - 8 PM )',
];

export const WALKTHROUGH_PANATCH_TIME_SLOTS = [
  'Mornings ( 7 AM - 11 AM )',
  'Afternoons ( 1 PM - 5 PM )',
  'Evenings ( 5 PM - 8 PM )',
];

export const WALKTHROUGH_ALBASTAR_TIME_SLOTS = [
  '7:30 - 11:30',
  '11:30 - 3:30',
  'All day',
];
export const S3BucketConfig = {
  bucketName: `${import.meta.env.VITE_ENVIRONMENT}-juniper-file-store`,
  region: 'ca-central-1',
  url: `https://${import.meta.env.VITE_ENVIRONMENT}-juniper-file-store.s3.ca-central-1.amazonaws.com/`,
};

// juniper key

export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

export const PAGINATION_LIMIT = '100';

export const HOTJAR_VERSION = 6;

export const STATUSES = [
  { label: 'Submitted', value: 'Submitted' },
  { label: 'Scheduled', value: 'Scheduled' },
  { label: 'En Route', value: 'En Route' },
  { label: 'On Hold', value: 'On Hold' },
  { label: 'In Progress', value: 'In Progress' },
  { label: 'Resolved', value: 'Resolved' },
  { label: 'Declined', value: 'Declined' },
  { label: 'Closed', value: 'Closed' },
  { label: 'Archive', value: 'Archive' },
  { label: 'Assigned', value: 'Assigned' },
  { label: 'Under Review', value: 'Under Review' },
  { label: 'Approved', value: 'Approved' },
  { label: 'One Year Warranty', key: 'One Year Warranty' },
];
export const STATUS_MESSAGES = (branding) => [
  {
    status: 'Submitted',
    message: `You have received a ${branding.text.serviceRequest}.`,
  },
  { status: 'Under Review', message: 'Service Request has been Under Review.' },
  { status: 'Approved', message: 'Service Request has been approved.' },
  { status: 'Assigned', message: 'Service Request has been assigned.' },
  { status: 'Scheduled', message: 'Scheduled for: ' },
  { status: 'En Route', message: 'En Route to: ' },
  { status: 'On Hold', message: 'This Service Request has been put On Hold' },
  { status: 'In Progress', message: 'In Progress at: ' },
  { status: 'Resolved', message: 'Service Request has been Resolved.' },
  { status: 'Declined', message: 'Service Request was Declined.' },
  { status: 'Closed', message: 'Service Request has been Closed.' },
  { status: 'Archive', message: 'Archive' },
  {
    status: 'One Year Warranty',
    message: 'One Year Warranty Service Request.',
  },
];

export const NETWORK_CONNECTION_CHECK_MESSAGE =
  'Please wait, while we are trying to fetch your network speed to proceed the save offline data.';
export const UNSTABLE_NETWORK_CONNECTION_CHECK_MESSAGE =
  'You dont have a stable internet connection to proceed the save offline data.';
export const NETWORK_CHECK_IMAGE_URL = `${S3BucketConfig.url}NetworkCheckImage20220627124216`;

export const NETWORK_CHECK_IMAGE_SIZE = 5739426;

export const USER_ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  PROPERTY_DEVELOPER: 'Property Developer',
  STRATA_MANAGER: 'Strata Manager',
  HOME_OWNER: 'Home Owner',
  REALTOR: 'Realtor',
  SERVICE_PROVIDER: 'Service Provider',
  VENDOR: 'Vendor',
  OCCUPANT: 'Occupant',
  SERVICE_MANAGER: 'Service Manager',
};

export const AGORA_VIDEO_CALL_APP_ID = 'f8cc45c1de7c4a1dbc6afa01385ea94e';

/*
    Created By: Sai Prasad
    Created Date: 25/08/2022
    Description: Success messages.
*/
export const SuccessMessages = {
  passwordSuccess:
    ' ⓘ You have changed your password. Please sign In with your credentials.',
  propertyAdded: 'ⓘ Property has been added.',
  pdfDownloadNotification:
    'PDF generation is in process and will be downloaded shortly.',
  specificationSaved: 'Specification saved successfully',
  specificationUpdated: 'Specification updated successfully',
  specificationDeleted: 'Specification deleted successfully',
};

/*
    Created By: Sai Prasad
    Created Date: 25/08/2022
    Description: Error messages.
*/
export const ErrorMessages = {
  passwordValidation:
    'Your new password and confirm password must be the same.',
  userNotFound: 'User is not found.',
  userAlreadyActivated: 'User already activated.',
  linkHasExpired: 'Link has expired',
  passwordFail: 'Password update fail, please try again.',
  suitesImportError: 'Suites import failed',
  catalogImportError: 'Catalogs import failed',
  error: 'Something went wrong, please try again.',
  csvValidation:
    'The file does not match the template. Please download the template and upload again.',
  noDatacsv: 'There is no data available in your file to upload.',
  areasFetchFailed: 'Rooms fetching failed, please try again.',
  propertyAddError:
    ' 🚫 Something went wrong with adding a property, please try again.',
  passwordRequirement1: 'Must contain between 8 to 20 characters',
  passwordRequirement2:
    'Must contain at least one capital (uppercase) letter (ex: A-Z)',
  passwordRequirement3: 'Must contain at least one lowercase letter (ex: a-z)',
  passwordRequirement4: 'Must contain at least one number (ex: 0-9)',
  passwordRequirement5: `Must contain at least one special character (ex: "!@#$%^&*()`,
  wrongPassword:
    'Your old password has incorrect, please provide the valid password',
  specificationFailed: 'Specification saving failed',
  specificationUpdateFailed: 'Specification updating failed',
  specificationDeleteFailed: 'Specification deleting failed',
  sendEmailFailed: 'Something went wrong while sending an email to receiver',
};

/*
    Created By: Sai Prasad
    Created Date: 26/08/2022
    Jira Ticket: JUN-2692
    Description: suite headers for download csv template.
*/

export const SuiteHeaders = [
  { label: 'Number', key: 'Number' },
  { label: 'Status', key: 'Status' },
  { label: 'Stratalot', key: 'Stratalot' },
  { label: 'WarrantyDefaultStartDate', key: 'WarrantyDefaultStartDate' },
  { label: 'Rooms', key: 'Rooms' },
  { label: 'Assets', key: 'Assets' },
];
const suite = localStorage.getItem('theme') === 'Shape' ? 'Unit' : 'Suite';
export const SuiteDummyData = [
  {
    Number: `${suite} 1`,
    Status: 'Active',
    Stratalot: 'Test',
    WarrantyDefaultStartDate: moment().format('MM/DD/YYYY'),
    Rooms: 'Bedroom1',
    Assets: 'AC#Cabinatory',
  },
  {
    Number: `${suite} 1`,
    Status: 'Active',
    Stratalot: '',
    WarrantyDefaultStartDate: moment().format('MM/DD/YYYY'),
    Rooms: 'Bedroom2',
    Assets: 'Fan',
  },
  {
    Number: `${suite} 2`,
    Status: 'Active',
    Stratalot: '',
    WarrantyDefaultStartDate: moment().format('MM/DD/YYYY'),
    Rooms: 'Bedroom2',
    Assets: 'AC#Cabinatory',
  },
];
/*
    Created By: Sai Prasad
    Created Date: 29/08/2022
    Jira Ticket: JUN-3154
    Description: catalog headers for download csv template.
*/
export const CatalogHeaders = [
  { label: 'Name', key: 'Name' },
  { label: 'Type', key: 'Type' },
  { label: 'Warranty', key: 'Warranty' },
  { label: 'Make', key: 'Make' },
  { label: 'Model', key: 'Model' },
  { label: 'Properties', key: 'Properties' },
];

export const CatalogDummyData = [
  {
    Name: 'Test',
    Type: 'itemType',
    Warranty: 3,
    Make: 'Make',
    Model: 'itemModel',
    Properties: 'Property1&Property2',
  },
];

/**
 * Created By: Sai Prasad
 * Created Date: 29/09/2022
 * Jira Ticket: JUN-3214
 * Description: Intro content to tabs in suite level
 */
export const IntroContent = {
  rooms:
    "Below you'll find an inventory of all of the rooms and items in your home. Click any of these items for detailed information including manuals, maintenance reminders, FAQ and more.",
  serviceRequests:
    'Have a warranty service request? Submit your request here, and view existing requests to check in on their status.',
  manualsAndDocuments:
    'Important documents and operator manuals for the various systems and items in your home are available here, along with other documentation including homeowner manuals, warranty documents and more.',
  maintenanceReminders:
    'Learn about the various activities you should take to keep your home well maintained.',
};

export const repeatTypes = ['Weekly', 'Monthly', 'Annually', 'Custom'];
export const repeatStartHours = 1;
export const repeatEndHours = 30;

export const repeatEveryTypes = ['Day', 'Week', 'Month', 'Year'];

export const crossIcon =
  'M0.928968 0.929094C1.16339 0.694674 1.48133 0.562977 1.81285 0.562978C2.14437 0.562978 2.46231 0.694674 2.69673 0.929095L8.00003 6.23239L13.3033 0.929094C13.5377 0.694674 13.8557 0.562978 14.1872 0.562978C14.5187 0.562977 14.8367 0.694674 15.0711 0.929094C15.3055 1.16351 15.4372 1.48146 15.4372 1.81298C15.4372 2.1445 15.3055 2.46244 15.0711 2.69686L9.76779 8.00015L15.0711 13.3034C15.3055 13.5379 15.4372 13.8558 15.4372 14.1873C15.4372 14.5188 15.3055 14.8368 15.0711 15.0712C14.8367 15.3056 14.5187 15.4373 14.1872 15.4373C13.8557 15.4373 13.5377 15.3056 13.3033 15.0712L8.00003 9.76792L2.69673 15.0712C2.46231 15.3056 2.14437 15.4373 1.81285 15.4373C1.48133 15.4373 1.16339 15.3056 0.928968 15.0712C0.694548 14.8368 0.562852 14.5188 0.562852 14.1873C0.562853 13.8558 0.694548 13.5379 0.928969 13.3034L6.23226 8.00015L0.928969 2.69686C0.694548 2.46244 0.562853 2.1445 0.562852 1.81298C0.562852 1.48146 0.694548 1.16351 0.928968 0.929094Z';

export const webUrlAccess = window.location.origin;

export const repeatHours = [1, 2, 3, 4, 6, 8, 12, 24];
